import React from 'react';

import InfiniteScroll from "react-infinite-scroll-component";

import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import {makeStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import {numberFormatter} from "../../utils/descriptionTemplate";

const useStyles = makeStyles(theme => (
        {
            offenseRow: {
                padding: theme.spacing(1),
                '&:hover': {
                    cursor: 'pointer',
                    backgroundColor: '#E78E09',
                }
            },
            closeButton: {
                color: theme.palette.grey[500],
            },
            dialogTitle: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                margin: 0,
                padding: 0
            },
            paper: {
                backgroundColor: '#F2F2F2',
                height: 'calc(100% - 64px)'

            },
            searchContainer: {
                backgroundColor: 'white',
                margin: '25px 25px 0 25px',
                padding: '20px 30px',
            },
            blackDivider: {
                margin: '0 25px',
            },
            tableHeader: {
                width: 'auto',
                margin: '0 25px',
                padding: '8px 28px 8px 23px',
                backgroundColor: '#ffffff',
            },
            tableHeaderText: {
                fontWeight: 500
            },
            dialogContentContainer: {
                flex: '1 1 auto',
                padding: '0',
                margin: '0 25px 25px 25px',
                overflowY: 'scroll',
                backgroundColor: 'white',
                '-webkit-overflow-scrolling': 'touch',
                '&::-webkit-scrollbar': {
                    width: '20px',
                    backgroundColor: 'white'
                },

                '&::-webkit-scrollbar-track': {
                    backgroundColor: 'transparent'
                },

                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#d6dee1',
                    borderRadius: '20px',
                    border: '6px solid transparent',
                    backgroundClip: 'content-box',
                },

                '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#a8bbbf'
                },
            },
            offensesContainer: {
                backgroundColor: "white",
                paddingLeft: '15px'
            },
            boldDivider: {
                height: '2px',
                backgroundColor: '#000000'
            },
            dialogRoot: {
                '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(0,0,0,0)'
                }
            }
        }
    )
)

const getNormativeArticleRowKey = (id) => `offense-select-offense-row-${id}`

const NormativeArticleRow = ({normativeArticle, normativeDocument, onClick}) => {
    const classes = useStyles()

    return <>
        <Grid item container className={classes.offenseRow} onClick={onClick} direction={"row"} wrap={"nowrap"}>
            <Grid item xs={2}>
                <Typography variant={'body1'}>{numberFormatter(normativeArticle?.number)}</Typography>
            </Grid>
            <Grid item xs>
                <Typography variant={'body1'}>{normativeArticle?.short_text}</Typography>
            </Grid>
            <Grid item xs>
                <Typography variant={'body1'}>{normativeDocument?.name}</Typography>
            </Grid>
        </Grid>
        <Divider/>
    </>
}

export const NormativeArticleDialog = ({
                                           shadow,
                                           isOpenNormativeArticleDialog,
                                           closeNormativeArticleDialog,
                                           handbookName,
                                           searchText,
                                           handleSearchChange,
                                           normativeArticles,
                                           normativeDocuments,
                                           onNext,
                                           scrollRef,
                                           onNormativeArticleRowClick
                                       }) => {
    const classes = useStyles()

    return <Dialog open={isOpenNormativeArticleDialog}
                   onClose={closeNormativeArticleDialog}
                   fullWidth maxWidth={'md'}
                   scroll={'paper'}
                   classes={
                       {
                           root: !shadow ? classes.dialogRoot : undefined,
                           paper: classes.paper
                       }
                   }
    >
        <DialogTitle disableTypography classes={{root: classes.dialogTitle}}>
            <Grid item container justifyContent={'space-between'} alignItems={"center"} xs>
                <Grid item/>
                <Grid item>
                    <Typography variant={'body1'}>{handbookName}</Typography>
                </Grid>
                <Grid item>
                    <IconButton aria-label="close" className={classes.closeButton}
                                onClick={closeNormativeArticleDialog}>
                        <CloseIcon/>
                    </IconButton>
                </Grid>
            </Grid>

            <Divider light={false} className={classes.boldDivider}/>
            <Grid item className={classes.searchContainer}>
                <div>
                    <TextField
                        size={'small'}
                        variant="outlined"
                        label={'Введите слово или предложение'}
                        fullWidth
                        value={searchText}
                        onChange={handleSearchChange}
                        id="search-text-field"
                        InputProps={{
                            endAdornment: <IconButton>
                                <SearchIcon/>
                            </IconButton>
                        }}
                    />
                </div>
            </Grid>
            <Grid item>
                <Divider className={classes.blackDivider}/>
            </Grid>
            <Grid item container className={classes.tableHeader}>
                <Grid xs={2} item container justifyContent={"center"}>
                    <Grid item>
                        <Typography variant={'body1'} className={classes.tableHeaderText}>Номер</Typography>
                    </Grid>
                </Grid>
                <Divider orientation="vertical" flexItem/>
                <Grid xs item container justifyContent={"center"}>
                    <Grid item>
                        <Typography variant={'body1'} className={classes.tableHeaderText}>Нормативный пункт</Typography>
                    </Grid>
                </Grid>
                <Divider orientation="vertical" flexItem/>
                <Grid xs item container justifyContent={"center"}>
                    <Grid item>
                        <Typography variant={'body1'} className={classes.tableHeaderText}>Нормативный
                            документ</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item className={classes.blackDivider}>
                <Divider/>
            </Grid>
        </DialogTitle>
        <DialogContent ref={scrollRef} id={'offense-list'} classes={{root: classes.dialogContentContainer}}>
            <InfiniteScroll className={classes.offensesContainer}
                            style={{overflow: 'hidden'}}
                            dataLength={normativeArticles.results.length}
                            next={onNext}
                            hasMore={Boolean(normativeArticles.next)}
                            loader={<CircularProgress/>}
                            scrollableTarget={'offense-list'}

            >
                {normativeArticles.results.map(el =>
                    <NormativeArticleRow key={getNormativeArticleRowKey(el.id)}
                                         onClick={onNormativeArticleRowClick(el)}
                                         normativeArticle={el}
                                         normativeDocument={normativeDocuments[el.normative_document]}
                    />
                )}
            </InfiniteScroll>
        </DialogContent>
    </Dialog>
}